/**
 * Helpers to safely access Datadog RUM and LOGS in browser without bundling the library.
 * Returns undefined on server-side or if Datadog is not initialized.
 */

// Dispatched on window once RUM is initialized, for code that mounts before the lazy init.
export const DATADOG_RUM_INITIALIZED_EVENT = "datadog-rum-initialized";

export const getDatadogRum = () => {
    if (typeof window === "undefined") return undefined;
    return window.DD_RUM;
};

export const getDatadogLogs = () => {
    if (typeof window === "undefined") return undefined;
    return window.DD_LOGS;
};
